export default __webpack_public_path__ + "static/media/create-token-ball.67434318.png";